// extracted by mini-css-extract-plugin
export var icon = "styles-module--icon--2392c";
export var itemTitle = "styles-module--item-title--60b19";
export var list = "styles-module--list--bb3cf";
export var title = "styles-module--title--98111";